export default class TransactionClassificationIncludesRepository {
  public getForTransactionType(type: string) : string[] {
    const types: string[] | undefined = this.CLASSIFICATION_TYPE_MAP.get(type);
    return (types) ? Object.assign([], types) : [];
  }

  public isFillableType(type:string) : boolean {
    return !!this.CLASSIFICATION_TYPE_MAP.get(type);
  }

  private static readonly GROCERY_PURCHASE_INCLUDES =
    ['$1.00 STORE',
      '1.00 STORE',
      'ALBERTSON',
      'ALBERTSONS',
      'ALDI',
      'BROOKSHIRE',
      'BROOKSHIRES',
      'CASH WISE',
      'CENTRAL MARKET',
      'COBORNS',
      'COSTCO',
      'CUB FOODS',
      'DEARBORN MARKET',
      'DILLONS',
      'DOLLAR GENERAL',
      'DOLLAR TREE',
      'DOLLAR-GENERAL',
      'DOLLARTREE',
      'FAMILY DOLLAR',
      'FAMILY FA',
      'FAMILY FARE',
      'FOOD LION',
      'FOOD PRIDE',
      'FOODLION',
      'FRESH GROCER',
      'FRESH THYME',
      'FRESHGROCER',
      'FRESHTHYME',
      'GIANT',
      'GOURMET GARAGE',
      'H-E-B',
      'H.E.B',
      'HANNAFORD',
      'HARRIS TEETER',
      'HEB',
      'HY-VEE',
      'KROGER',
      'MEIJER',
      'PIGGLY WIGGLY',
      'PIGGLYWIGGLY',
      'PRICERITE',
      'PUBLIX',
      'RANDALLS',
      'SAFEWAY',
      'SAMS CLUB',
      'SAVE A LOT',
      'SAVE-A-LOT',
      'SHOPRITE',
      'SMITHS',
      'SMITHS FOOD',
      'SMITHS MRKTPL',
      'SMITHSFOOD',
      'SPROUTS',
      'STOP & SHOP',
      'STOP + SHOP',
      'STOP - N -SHOP',
      'STOP -N -SHOP',
      'STOP N SHOP',
      'TARGET',
      'TRADER JOE',
      'TRADER JOES',
      'TRADERJOES',
      "VG'S",
      'VGS',
      'VONS',
      'WAL MART',
      'WAL-MART',
      'WALMART',
      'WEGMANS',
      'WHOLE FOODS',
      'WHOLEFDS',
      'WHOLEFOODS',
      'WINCO',
      'WM SUPERCENTER'];

  private static readonly MEAL_DELIVERY_INCLUDES =
    ['DOORDASH',
      'FAVOR',
      'FOOD DUDES',
      'GRUB HUB',
      'GRUBHUB',
      'INSTACART',
      'POSTMATES',
      'SHIPT',
      'UBER   EATS',
      'UBER  EATS',
      'UBER EATS',
      'UBER* EATS'];

  private static readonly VIDEO_STREAM_INCLUDES =
    ['AMAZON MUSIC',
      'AMAZON PRIME',
      'APPLE.COM',
      'APPLE COM',
      'CBS ALL ACCESS',
      'CBS Interac',
      'CBS Interac tive',
      'CBS INTERACTIVE',
      'CBSAllAcces',
      'CBSALLACCESS',
      'CRUNCHYROLL',
      'DISCOVERY COM',
      'DISCOVERY.COM',
      'DISCOVERYPLUS',
      'DISNEY P',
      'DISNEY PLUS',
      'DISNEYPLUS',
      'ESPN',
      'FUBO',
      'FUNIMATI',
      'FUNIMATION',
      'HBOMAX',
      'HULU',
      'MAX.COM',
      'NETFLIX',
      'PARAMANTP',
      'PEACOCK',
      'PRIME VIDEO',
      'SHOWTIME',
      'SLING',
      'STARZ',
      'YOUTUB',
      'YOUTUBE',
      'YOUTUBEPREMIUM'];

  private static readonly GAME_STREAMING_INCLUDES =
    ['NINTENDO',
      'PLAYSTATION',
      'TWITCH',
      'XBOX'];

  private static readonly AUDIO_STREAMING_INCLUDES =
    ['AMAZON MUSIC',
      'APPLE COM',
      'APPLE.COM',
      'GOOGLE *YOUTUBE MUSIC',
      'GOOGLE *YOUTUBEPREMIUM',
      'GOOGLE \\*YOUTUBE MUSIC',
      'GOOGLE \\*YOUTUBEPREMIUM',
      'iHeartMedi',
      'IHEARTMEDIA',
      'PANDORA',
      'SOUNDCLOUD',
      'SPOTIFY',
      'TIDAL',
      'YOUTUBEMUSIC'];

  private readonly CLASSIFICATION_TYPE_MAP : Map<string, string[]> = new Map([
    ['GROCERY_PURCHASE', TransactionClassificationIncludesRepository.GROCERY_PURCHASE_INCLUDES],
    ['MEAL_DELIVERY_PURCHASE', TransactionClassificationIncludesRepository.MEAL_DELIVERY_INCLUDES],
    ['VIDEO_STREAMING_PURCHASE', TransactionClassificationIncludesRepository.VIDEO_STREAM_INCLUDES],
    ['GAMING_STREAMING_PURCHASE', TransactionClassificationIncludesRepository.GAME_STREAMING_INCLUDES],
    ['AUDIO_STREAMING_PURCHASE', TransactionClassificationIncludesRepository.AUDIO_STREAMING_INCLUDES],
  ]);
}
